import { formatGhs } from 'pages/FuelManagement/Shared/fuelFormatters'
import { IStatusPill } from 'types/ui/statusPill.interface'
import { IInventorySupplierCommercials } from 'types/inventorySupply.interface'
import { IInventorySupplierCommercialsResponse } from 'types/api/inventoryControlApi.interface'
import { InventoryReceiptQcResult } from 'types/inventoryEnums.interface'
import { RECEIPT_QC_RESULT_META } from './Shared/inventoryEnumMaps'

export const formatSupplyGhs = (value: number): string => formatGhs(value)

export const RECEIPT_QC_META: {
  [k: string]: { label: string; tone: IStatusPill['status'] }
} = {
  PASS: RECEIPT_QC_RESULT_META[InventoryReceiptQcResult.Pass],
  REJECTED: RECEIPT_QC_RESULT_META[InventoryReceiptQcResult.Rejected],
  PENDING: RECEIPT_QC_RESULT_META[InventoryReceiptQcResult.Pending],
  [String(InventoryReceiptQcResult.Pass)]: RECEIPT_QC_RESULT_META[InventoryReceiptQcResult.Pass],
  [String(InventoryReceiptQcResult.Rejected)]:
    RECEIPT_QC_RESULT_META[InventoryReceiptQcResult.Rejected],
  [String(InventoryReceiptQcResult.Pending)]: RECEIPT_QC_RESULT_META[InventoryReceiptQcResult.Pending],
}

export const INVENTORY_DEMO_SUPPLIERS: any[] = []
export const INVENTORY_DEMO_RECEIPTS: any[] = []

export const getInventorySupplierCommercials = (
  _name: string,
  commercials?: IInventorySupplierCommercialsResponse | null,
): IInventorySupplierCommercials | null => {
  if (!commercials) return null
  return {
    supplierName: _name,
    avgLeadTimeDays: commercials.avgLeadTimeDays ?? 0,
    promisedLeadTimeDays: commercials.promisedLeadTimeDays ?? 0,
    onTimePct: commercials.onTimePct ?? 0,
    lastPriceMoveLabel: commercials.lastPriceMoveLabel ?? '—',
    openOrdersCount: commercials.openOrdersCount,
    openOrdersValueGhs: commercials.openOrdersValueGhs,
    note: commercials.note ?? undefined,
  }
}

export const supplierLeadDeltaDays = (c: IInventorySupplierCommercials): number =>
  Math.round((c.avgLeadTimeDays ?? 0) - (c.promisedLeadTimeDays ?? 0))

export const supplierLeadDeltaTone = (c: IInventorySupplierCommercials): IStatusPill['status'] => {
  const delta = supplierLeadDeltaDays(c)
  if (delta > 2) return 'danger'
  if (delta > 0) return 'warning'
  return 'success'
}

export const supplierOnTimeTone = (pct: number): IStatusPill['status'] => {
  if (pct >= 90) return 'success'
  if (pct >= 75) return 'warning'
  return 'danger'
}
